import React, { useState, useCallback, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Template from './template';
import * as S from './style';
import { Label, SpaceDiv, Login } from 'components';

import { useAuthVerify } from 'hooks';
import { validatePhone } from 'commons/ZimssaHelper';
import { apiPartnerLogin } from 'api/ZimssaAPI';
import { SERVICE_SELECT } from 'router/PageUrl';
import { PartnerAuthAction } from 'stores/PartnerAuthStore';
import { IPartnerAuthState } from 'stores/PartnerAuthStore/state';
import { BUTTON_NEXT, TITLE_PARTNER_LOGIN } from 'commons/ZimssaString';

interface MainForm {
    isActive: boolean;
    isComplete: boolean;
}

function PartnerLoginView(): React.ReactElement {
    const history = useHistory();
    const { timer, isSend, isReSend, isVerify, sendSMSCallback, authVerifyCallback, changeIsVerify } = useAuthVerify();
    const [phone, setPhone] = useState<string>('');
    const [authCode, setAuthCode] = useState<string>('');

    const dispatcher = useContext(PartnerAuthAction);

    // 인증 하기
    const onClickVerifyCallback = useCallback(
        (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            authVerifyCallback(phone, authCode, 'partner-web-signin');
        },
        [phone, authCode, authVerifyCallback]
    );

    const onClickLoginCallback = useCallback(
        (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            changeIsVerify();
            apiPartnerLogin(phone, authCode).then((response) => {
                const { result, data, message } = response;
                if (result === 'success') {
                    const responseData: {
                        accessToken: string;
                        partnerInfo: IPartnerAuthState;
                    } = data;

                    localStorage.setItem('access-token', responseData.accessToken);

                    dispatcher({
                        type: 'LOGIN',
                        value: {
                            ...Object.assign(responseData.partnerInfo, { isLogin: true }),
                        },
                    });

                    history.push(SERVICE_SELECT.url);
                } else {
                    if (message) alert(message);
                }
            });
        },
        [authCode, changeIsVerify, dispatcher, history, phone]
    );

    const signUpProps = {
        phone: {
            value: phone,
            isActive: (validatePhone(phone) && !isSend) || (validatePhone(phone) && isReSend),
            isSend: isSend,
            onChangeHandler: (type: any, value: string) => {
                setPhone(value);
            },

            onClickSendSMS: () => {
                if (phone) {
                    sendSMSCallback(phone, 'partner-web-signin');
                }
            },
        },
        authCode: {
            value: authCode,
            timer: timer,
            isVerify: isVerify,
            onClickVerify: onClickVerifyCallback,
            onChangeHandler: (type: any, value: string) => {
                setAuthCode(value);
            },
        },
        btnNext: {
            contents: BUTTON_NEXT,
            isActive: isVerify,
            isComplete: false,
            onClick: onClickLoginCallback,
        },
    };

    return (
        <Template>
            <S.TitleWrapper>
                <Label contents={TITLE_PARTNER_LOGIN} color={'gray_opacity_800'} fontStyle={'h3_bold'} />
            </S.TitleWrapper>
            <SpaceDiv height={20} />
            <Login {...signUpProps} />
        </Template>
    );
}

export default PartnerLoginView;
